/* eslint-disable react/jsx-no-target-blank */
import React from 'react'
import {useIntl} from 'react-intl'
import {KTIcon} from '../../../../helpers'
import {SidebarMenuItemWithSub} from './SidebarMenuItemWithSub'
import {SidebarMenuItem} from './SidebarMenuItem'
import {useUser} from '../../../../../app/modules/newauth/UserContext'
import {useLocation, useParams} from 'react-router-dom'

const SidebarMenuMain = () => {
  const intl = useIntl()
  const {user} = useUser()
  const location = useLocation()
  const deviceIdMatch = location.pathname.match(/^\/device\/([^/]+)$/)
  const isDeviceDetailPage = !!deviceIdMatch
  const deviceId = deviceIdMatch ? deviceIdMatch[1] : null

  return (
    <>
      <SidebarMenuItem
        to='/dashboard'
        icon='element-11'
        title={intl.formatMessage({id: 'MENU.DASHBOARD'})}
        fontIcon='bi-app-indicator'
      />

      {isDeviceDetailPage && (
        <>
          <SidebarMenuItemWithSub
            to={`/device/${deviceId}`}
            title='Device'
            icon='devices'
            fontIcon='bi-app-indicator'
          >
            <SidebarMenuItem
              to={`/device/${deviceId}#parameter`}
              title='Parameter'
              hasBullet={true}
            />

            <SidebarMenuItem to={`/device/${deviceId}#alarm`} title='Alarm' hasBullet={true} />

            <SidebarMenuItem to={`/device/${deviceId}#vbox`} title='V-Box' hasBullet={true} />

            <SidebarMenuItem
              to={`/device/${deviceId}#send-command`}
              title='Send Command'
              hasBullet={true}
            />

            <SidebarMenuItem to={`/device/${deviceId}#setting`} title='Setting' hasBullet={true} />
          </SidebarMenuItemWithSub>

          {/* <SidebarMenuItem
            to={`/device/${deviceId}`}
            icon='time'
            title='Device'
            fontIcon='bi-device'
          />
          <SidebarMenuItem
            to={`/device/${deviceId}#alarm`}
            icon='warning'
            title='Realtime Data'
            fontIcon='bi-clock'
          />
          <SidebarMenuItem
            to={`/device/${deviceId}#alarm`}
            icon='warning'
            title='Alarm'
            fontIcon='bi-bell'
          />
          <SidebarMenuItem
            to={`/device/${deviceId}#parameter`}
            icon='database'
            title='Parameter'
            fontIcon='bi-sliders'
          />
          <SidebarMenuItem
            to={`/device/${deviceId}#vbox`}
            icon='box'
            title='V-Box'
            fontIcon='bi-box'
          /> */}
        </>
      )}
      {/* <SidebarMenuItem to='/builder' icon='switch' title='Layout Builder' fontIcon='bi-layers' /> */}
      {/* <div className='menu-item'>
        <div className='menu-content pt-8 pb-2'>
          <span className='menu-section text-muted text-uppercase fs-8 ls-1'>Crafted</span>
        </div>
      </div> */}

      {/* <SidebarMenuItemWithSub
        to='/crafted/pages'
        title='Pages'
        fontIcon='bi-archive'
        icon='element-plus'
      >
        <SidebarMenuItemWithSub to='/crafted/pages/profile' title='Profile' hasBullet={true}>
          <SidebarMenuItem to='/crafted/pages/profile/overview' title='Overview' hasBullet={true} />
          <SidebarMenuItem to='/crafted/pages/profile/projects' title='Projects' hasBullet={true} />
          <SidebarMenuItem
            to='/crafted/pages/profile/campaigns'
            title='Campaigns'
            hasBullet={true}
          />
          <SidebarMenuItem
            to='/crafted/pages/profile/documents'
            title='Documents'
            hasBullet={true}
          />
          <SidebarMenuItem
            to='/crafted/pages/profile/connections'
            title='Connections'
            hasBullet={true}
          />
        </SidebarMenuItemWithSub>

        <SidebarMenuItemWithSub to='/crafted/pages/wizards' title='Wizards' hasBullet={true}>
          <SidebarMenuItem
            to='/crafted/pages/wizards/horizontal'
            title='Horizontal'
            hasBullet={true}
          />
          <SidebarMenuItem to='/crafted/pages/wizards/vertical' title='Vertical' hasBullet={true} />
        </SidebarMenuItemWithSub>
      </SidebarMenuItemWithSub> */}

      {/* <SidebarMenuItemWithSub
        to='/crafted/accounts'
        title='Accounts'
        icon='profile-circle'
        fontIcon='bi-person'
      >
        <SidebarMenuItem to='/crafted/account/overview' title='Overview' hasBullet={true} />
        <SidebarMenuItem to='/crafted/account/settings' title='Settings' hasBullet={true} />
      </SidebarMenuItemWithSub>

      <SidebarMenuItemWithSub to='/error' title='Errors' fontIcon='bi-sticky' icon='cross-circle'>
        <SidebarMenuItem to='/error/404' title='Error 404' hasBullet={true} />
        <SidebarMenuItem to='/error/500' title='Error 500' hasBullet={true} />
      </SidebarMenuItemWithSub>
      <SidebarMenuItemWithSub
        to='/crafted/widgets'
        title='Widgets'
        icon='element-7'
        fontIcon='bi-layers'
      >
        <SidebarMenuItem to='/crafted/widgets/lists' title='Lists' hasBullet={true} />
        <SidebarMenuItem to='/crafted/widgets/statistics' title='Statistics' hasBullet={true} />
        <SidebarMenuItem to='/crafted/widgets/charts' title='Charts' hasBullet={true} />
        <SidebarMenuItem to='/crafted/widgets/mixed' title='Mixed' hasBullet={true} />
        <SidebarMenuItem to='/crafted/widgets/tables' title='Tables' hasBullet={true} />
        <SidebarMenuItem to='/crafted/widgets/feeds' title='Feeds' hasBullet={true} />
      </SidebarMenuItemWithSub>

      <div className='menu-item'>
        <div className='menu-content pt-8 pb-2'>
          <span className='menu-section text-muted text-uppercase fs-8 ls-1'>Apps</span>
        </div>
      </div>
      <SidebarMenuItemWithSub
        to='/apps/chat'
        title='Chat'
        fontIcon='bi-chat-left'
        icon='message-text-2'
      >
        <SidebarMenuItem to='/apps/chat/private-chat' title='Private Chat' hasBullet={true} />
        <SidebarMenuItem to='/apps/chat/group-chat' title='Group Chart' hasBullet={true} />
        <SidebarMenuItem to='/apps/chat/drawer-chat' title='Drawer Chart' hasBullet={true} />
      </SidebarMenuItemWithSub> */}

      {user?.role === 'admin' && (
        <>
          <SidebarMenuItem
            to='/user-management'
            icon='user'
            title='User Management'
            fontIcon='bi-layers'
          />

          <SidebarMenuItem
            to='/device-note'
            icon='cheque'
            title='Device Notes'
            fontIcon='bi-layers'
          />
        </>
      )}

      {/* <div className='menu-item'>
        <a
          target='_blank'
          className='menu-link'
          href={process.env.REACT_APP_PREVIEW_DOCS_URL + '/docs/changelog'}
        >
          <span className='menu-icon'>
            <KTIcon iconName='code' className='fs-2' />
          </span>
          <span className='menu-title'>Changelog {process.env.REACT_APP_VERSION}</span>
        </a>
      </div> */}
    </>
  )
}

export {SidebarMenuMain}
